import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api-client';

export interface CardCounts {
    authoritative: number;
    federated: number;
    total: number;
}

export interface RegistrySyncInfo {
    registry_id: string;
    alias: string;
    display_name?: string;
    kind: string;
    status: string;
    last_seen_at?: string;
    card_counts: CardCounts;
    supports_federation: boolean;
}

export interface FederationStatus {
    registries: RegistrySyncInfo[];
    total_cards: number;
}

export interface RecentCard {
    id: string;
    cap_id: string;
    origin: string;
    type: string;
    title?: string;
    modified: string;
}

export interface RegistrySyncDetail {
    registry_id: string;
    alias: string;
    display_name?: string;
    kind: string;
    status: string;
    last_seen_at?: string;
    card_counts: CardCounts;
    recent_cards: RecentCard[];
}

export function useFederationStatus() {
    return useQuery<FederationStatus>({
        queryKey: ['federation-status'],
        queryFn: () => api.get('/federation/status').then((r) => r.data),
        refetchInterval: 30_000,
    });
}

export function useRegistrySyncDetail(registryId: string) {
    return useQuery<RegistrySyncDetail>({
        queryKey: ['federation-status', registryId],
        queryFn: () =>
            api.get(`/federation/status/${registryId}`).then((r) => r.data),
        enabled: !!registryId,
        refetchInterval: 30_000,
    });
}
